import urls from "web/constants/urls";

const links = {
  pl: [
    { url: "/regulamin", name: "Regulamin", position: 100 },
    {
      url: "https://www.benefitsystems.pl/polityka-cookies/",
      name: "Polityka cookies",
      isAnchor: true,
      position: 200,
      openInNewTab: true,
    },
    {
      url: "https://www.benefitsystems.pl/polityka-prywatnosci/",
      name: "Polityka prywatności",
      isAnchor: true,
      position: 300,
      openInNewTab: true,
    },
    {
      // eslint-disable-next-line
      url: "javascript:Didomi.preferences.show()",
      name: "Ustawienia cookies",
      isAnchor: true,
      position: 400,
    },
    {
      url: "https://www.benefitsystems.pl/informacja-o-dostepnosci/",
      name: "Informacja o dostępności",
      isAnchor: true,
      position: 500,
      openInNewTab: true,
    },
    { url: "/lp/payu.html", name: "Płatności PayU", position: 600 },
    { url: "/lp/paypo.html", name: "Płatności PayPo", position: 700 },
    { url: urls.howWeSortProducts, name: "Zasady wyświetlania ofert", position: 800 },
  ],
  en: [
    { url: "/regulamin", name: "Regulamin", position: 100 },
    {
      url: "https://www.benefitsystems.pl/en/cookies-policy/",
      name: "Polityka cookies",
      isAnchor: true,
      position: 200,
      openInNewTab: true,
    },
    {
      url: "https://www.benefitsystems.pl/en/privacy-policy/",
      name: "Polityka prywatności",
      isAnchor: true,
      position: 300,
      openInNewTab: true,
    },
    {
      // eslint-disable-next-line
      url: "javascript:Didomi.preferences.show()",
      name: "Ustawienia cookies",
      isAnchor: true,
      position: 400,
    },
    {
      url: "https://www.benefitsystems.pl/en/accessibility-information/",
      name: "Accessibility Information",
      isAnchor: true,
      position: 500,
      openInNewTab: true,
    },
    { url: "/lp/payu.html", name: "Płatności PayU", position: 600 },
    { url: "/lp/paypo.html", name: "Płatności PayPo", position: 700 },
    { url: urls.howWeSortProducts, name: "Zasady wyświetlania ofert", position: 800 },
  ],
};

const getNavLinks = (
  languageCode: string
): {
  url: string;
  name: string;
  position: number;
  isAnchor?: boolean;
  openInNewTab?: boolean;
}[] => links[languageCode as keyof typeof links] ?? links.pl;

export default getNavLinks;
